
<div class="task-item shadowed-on-hover"
     [ngStyle]="{ borderLeftColor: 'completed'==data.status?'#6aa956':'#5cb9e6'}">

  <div>
    <!-- Title -->
    <h3 style="font-size: 1.15rem; display: inline-block; margin-right: 15px">#SR0{{i+171}}{{i+171}}{{i+29}}</h3>
    <!-- tags -->
    <nz-tag [nzColor]="'orange'" *ngIf="data.status=='pending'">Pending</nz-tag>
    <nz-tag [nzColor]="'green'" *ngIf="data.status=='completed'">Completed</nz-tag>
    <nz-tag [nzColor]="'blue'">Non-Financial</nz-tag>
  </div>


  <div class="task-item-grid">

    <div class="grid grid-4x grid-4x-responsive grid-gap-10 p-t-b-10">
      <div><strong class="c-s-heading">Policy Number</strong> P00{{i+171}}{{i+171}}{{i+29}}</div>
      <div><strong class="c-s-heading">Policy Owner</strong> Chris Hemsworth</div>
      <div><strong class="c-s-heading">Policy Commencement</strong> 12 Nov 2018, 10:15 AM</div>
      <div><strong class="c-s-heading">Insured Name</strong> Chris Hemsworth</div>
    </div>

    <div class="tags-equi-width">
      <nz-tag class="d-b w-100-pc" [nzColor]="'red'">SLA: Expired</nz-tag>
      <nz-tag class="d-b w-100-pc">Complexity: 8</nz-tag>
      <nz-tag class="d-b w-100-pc">Priority: 5</nz-tag>
    </div>

    <div>
      <button nz-button nzType="primary" class="w-100-pc b-r-0" [routerLink]="'/app/customer360/details/servicing'">Open</button>
      <button nz-button nzType="default" class="w-100-pc b-r-0">Auto-approve</button>
      <button nz-button nzType="default" class="w-100-pc b-r-0" (click)="isCollapsed=!isCollapsed">
        <div *ngIf="isCollapsed"><i nz-icon nzType="eye" nzTheme="outline"></i> Quick view</div>
        <div *ngIf="!isCollapsed"><i nz-icon nzType="eye" nzTheme="outline"></i> Quick view</div>
      </button>
    </div>
  </div>


  <div>

  </div>

  <div *ngIf="!isCollapsed">
    <nz-tabset style="height:auto" [nzSize]="'medium'">

      <!-- Address -->
      <nz-tab [nzTitle]="'Address'">
        <!-- Headings -->
        <div class="grid grid-2x txtdiff-head">
          <div>
            <h5>Existing record</h5>
          </div>
          <div>
            <h5 class="new">New</h5>
            <a class="f-r" (click)="editContents(content)">[edit]</a>
          </div>
        </div>
        <div class="txtdiff-outer">
        <td-ngx-text-diff
          [left]="content.leftContent"
          [right]="content.rightContent"
          [loading]="!submitted"
          [diffContent]="contentObservable$"
          [showToolbar]="false"
          [showBtnToolbar]="false"
          [outerContainerClass]="'txtdiff-outer'"
          [compareRowsClass]="'txtdiff-row'"
          [compareRowsStyle]="{'max-height': '540px', 'overflow': 'auto'}"
          (compareResults)="onCompareResults($event)"
        >
        </td-ngx-text-diff>
        </div>

        <div class="grid grid-2x">
          <div><!--Leave this empty--></div>
          <div>
            <p>
              <b><i class="anticon anticon-message"></i> Comment:</b> Wrong street address was provided by customer initially
            </p>
            <div class="text-a-right p-20-">
              <button nz-button nzType="primary">Accept New</button>
            </div>
          </div>
        </div>

      </nz-tab>

      <!-- Phone Number -->
      <nz-tab [nzTitle]="'Phone Number'">
        <!-- Headings -->
        <div class="grid grid-2x txtdiff-head">
          <div>
            <h5>Existing record</h5>
          </div>
          <div>
            <h5 class="new">New</h5>
            <a class="f-r" (click)="editContents(contentPhone)">[edit]</a>
          </div>
        </div>
        <div class="txtdiff-outer">
          <td-ngx-text-diff
            [left]="contentPhone.leftContent"
            [right]="contentPhone.rightContent"
            [loading]="!submitted"
            [diffContent]="contentObservable$"
            [showToolbar]="false"
            [showBtnToolbar]="false"
            [outerContainerClass]="'txtdiff-outer'"
            [compareRowsClass]="'txtdiff-row'"
            [compareRowsStyle]="{'max-height': '540px', 'overflow': 'auto'}"
            (compareResults)="onCompareResults($event)"
          >
            <!--[synchronizeScrolling]="true"-->
          </td-ngx-text-diff>
        </div>

        <div class="grid grid-2x">
          <div><!--Leave this empty--></div>
          <div>
            <p>
              <b><i class="anticon anticon-message"></i> Comment:</b> Data-entry operator typed in wrong value
            </p>
            <div class="text-a-right p-20-">
              <button nz-button nzType="primary">Accept New</button>
            </div>
          </div>
        </div>

      </nz-tab>

    </nz-tabset>
  </div>

</div>


<!-- HIDDEN MODAL FOR EDIT -->

<nz-modal nzMaskClosable="false" [(nzVisible)]="modalOpen"
          nzTitle="Modify"
          (nzOnCancel)="modalOpen=false" (nzOnOk)="modalOpen=false"
          nzOkText="Save"
>
  <div *ngIf="modalOpen">
    <textarea nz-input nzAutosize placeholder="Modify" [(ngModel)]="modalContent"></textarea>
  </div>
</nz-modal>
